const compactDisplays = {
  SHORT_LABEL: "SHORT_LABEL",
  AVATAR_INITIALS: "AVATAR_INITIALS",
  IDENTIFIER: "IDENTIFIER"
};

const compactDisplayLabels = {
  SHORT_LABEL: "Short label",
  AVATAR_INITIALS: "Avatar/Initials",
  IDENTIFIER: "Identifier"
};

const compactDisplayDescriptions = {
  SHORT_LABEL: "Use the item's existing label or specify a shortened version.",
  AVATAR_INITIALS: "Good for people item types. Use an image or initials like JS for Joe Smith",
  IDENTIFIER: "Good for project management tasks. Use a prefix and auto-generated number"
};

const getCompactDisplayOptions = selectedValue => {
  return Object.keys(compactDisplays).map(key => ({
    label: compactDisplayLabels[key],
    value: key,
    selected: selectedValue === key,
    description: compactDisplayDescriptions[key]
  }));
};

export { getCompactDisplayOptions };

export default compactDisplays;
